import { useEffect, useState } from "react";
import getFirestoreDocs from "../AcessoFirestore";
import Loading from "./loading";
import TabelaDados from "./TabelaDados"
import useAuth from "../context/useAuth";



function Dashboard(props) {
    const { logout } = useAuth();
    const [recursos, setRecursos] = useState([]);
    const [paginaCarregada, setPaginaCarregada] = useState(false);
    const [carregando, setCarregando] = useState(true);

    useEffect(()=> {
        
        const tokenAcesso = process.env.REACT_APP_MONGO_token;

        const requestOptions = {
            headers: {  token : tokenAcesso }
        };
        
        fetch(process.env.REACT_APP_API_RECURSOS, requestOptions)
        .then(recursos => recursos.json())
        .then(data => {
            setRecursos(data);
            setPaginaCarregada(true);
        }) 
        .catch(err => console.log(err))
      
    },[])

    useEffect(() => {
        if (paginaCarregada) {
          setCarregando(false);
        }
      }, [paginaCarregada]);


    return (



        <div style={{ background: '#1E1E2E', width: '100vw', height: '100vh' }}>

            {carregando ? <Loading /> : <TabelaDados recursos={recursos} />}

        </div>

    )
}

export default Dashboard;